<template>
  <div id="app">
    <RouterView />
  </div>
</template>

<script>
import appConfig from "@/app.config";
import { notificationMethods } from "@/state/helpers";
import { mapActions } from "vuex";
import incidentMixin from "./mixins/incident";

export default {
  name: "app",
  mixins: [incidentMixin],
  page: {
    titleTemplate (title) {
      title = typeof title === "function" ? title(this.$store) : title;
      return title ? `${title} | ${appConfig.title}` : appConfig.title;
    },
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    $route (to, from) {
      this.clearNotification();
    },
  },

  computed: {
    loading () {
      return this.$store.state.layout.loader;
    },
  },

  methods: {
    ...mapActions("incident", ["updateIncidents"]),
    clearNotification: notificationMethods.clear,
  },

  async mounted () {
    try {
      await this.GetAllMasterData();
    } catch (e) {
      console.error(e);
      // swal.fire("Master API Error", "Failed to fetch master data", "error");
    }
  },
};
</script>
<style>
body {
  -moz-transform: scale(1, 1);
  zoom: 1;
  zoom: 100%;
}

*::-webkit-input-placeholder {
  color: #c3c7dc !important;
}

*:-moz-placeholder {
  /* FF 4-18 */
  color: #c3c7dc !important;
  opacity: 1;
}

*::-moz-placeholder {
  /* FF 19+ */
  color: #c3c7dc !important;
  opacity: 1;
}

*:-ms-input-placeholder {
  /* IE 10+ */
  color: #c3c7dc !important;
}

*::-ms-input-placeholder {
  /* Microsoft Edge */
  color: #c3c7dc !important;
}

*::placeholder {
  /* modern browser */
  color: #c3c7dc !important;
}

.style-chooser .vs__disabled-bg {
  background: #333f78;
}

.style-chooser .vs__clear,
.style-chooser .vs__deselect,
.style-chooser .vs__open-indicator {
  fill: #c3c7dc;
}

textarea::placeholder,
input::placeholder {
  color: #7b8195 !important;
}

.vs--disabled .vs__clear,
.vs--disabled .vs__dropdown-toggle,
.vs--disabled .vs__open-indicator,
.vs--disabled .vs__search,
.vs--disabled .vs__selected {
  background-color: #1f2537 !important;
}

.style-chooser .vs__search::placeholder,
.style-chooser .vs__dropdown-toggle,
.style-chooser .vs__selected,
.style-chooser .vs__dropdown-menu {
  background: #2e3446;
  border: none;
  color: #c3c7dc;
}

.style-chooser .vs__selected {
  opacity: 1;
}

.style-chooser .vs__disabled-bg {
  background: #333f78;
}

.style-chooser .vs__clear,
.style-chooser .vs__deselect,
.style-chooser .vs__open-indicator {
  fill: #c3c7dc;
}

.filepond--root {
  font-family: "Poppins" !important;
  font-size: 13px !important;
}

.filepond--panel-root {
  background-color: #2e3446 !important;
}

.filepond--drop-label {
  color: #c3c7dc !important;
}

.mx-icon-calendar {
  color: #c3c7dc !important;
}</style>